import futura from '../assets/futura.png'
import { useState } from 'react';
import { Calendar } from 'react-date-range';
import 'react-calendar/dist/Calendar.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import close from '../assets/close.png'
import arrow from '../assets/arrow2.png'
import "date-fns";
import it from 'date-fns/locale/it';
function N3({ bookid, nextPage, previuosPage, home }) {
    const [date, setDate] = useState();


    const [ora, setOra] = useState()



    const editBook = () => {
        fetch(document.apiURL + '/book/' + bookid, {
            method: 'PUT',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "booking_date": date,
                "booking_time": ora
            })
        })
            .then(response => response.json())
            .then(response => {
                nextPage()
            });
    }

    return (<>
        <div className="back-profilazione">
            <div className="square-center" style={{ height: '90vh' }}>
            <div className="flex row sp" style={{ borderRadius: '16px 16px 0px 0px' }}>

<img src={arrow} onClick={()=> previuosPage()} /> 
<img src={close} onClick={()=> home()} />  

</div>
                <div className="flex row center-con sp">
                    <h2 className="c">Quando hai bisogno dell’intervento?</h2><img src={futura} className="min-fut">
                    </img>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>

                        <Calendar

                            onChange={item => { setDate(item) }}
                            locale={it}
                            date={date}
                            minDate={new Date()}

                        />
                    </div>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col " style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Preferenza oraria:</h4>
                        <div className="flex row"><button disabled={date === null ? true : false} className={`button-sel ${ora === '8-13' ? 'selected' : null}`} onClick={() => setOra('8-13')}>8-13</button> <button disabled={date === null ? true : false} className={`button-sel ${ora === '13-18' ? 'selected' : null}`} style={{ marginLeft: '10px' }} onClick={() => setOra('13-18')}>13-18</button><button disabled={date === null ? true : false} className={`button-sel ${ora === '18-21' ? 'selected' : null}`} style={{ marginLeft: '10px' }} onClick={() => setOra('18-21')}>18-21</button></div>


                    </div>
                </div>
                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <button disabled={ora === null ? true : false} onClick={() => editBook()} className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Continua</button>
                        <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>
                    </div>
                </div>




            </div>
        </div>
    </>
    );
}

export default N3;